export const deliverabilityPostmasterAppGroupIdDomains = "/deliverability/postmaster/:app_group_id/domains";
